<template>
  <div id="contract-detail" class="s-base">
    <v-card class="s-panel" max-width="1200">
      <div class="d-flex flex-row">
        <v-card-title class="s-title py-6">契約者詳細画面</v-card-title>
      </div>
      <v-container>
        <v-row>
          <v-col cols="2">契約者名</v-col>
          <v-col cols="9">
            <v-text-field
              v-model="userName"
              required
              class="ml-3 mr-3"
              maxlength="48"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">ＩＤ</v-col>
          <v-col cols="9">
            <v-text-field
              v-model="userId"
              required
              class="ml-3 mr-3"
              maxlength="5"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">パスワード</v-col>
          <v-col cols="2" md="auto">
            <v-btn
              class="ml-auto"
              color="secondary"
              @click="clearPassword()"
              width="100"
              >初期化</v-btn
            >
          </v-col>
          <v-col cols="7">
            <v-text-field
              v-if="dispPass"
              v-model="password"
              required
              readonly
              class="ml-3 mr-3"
              maxlength="128"
            />
            <div v-else class="py-2">契約者設定済み</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">契約内容</v-col>
          <v-col cols="9">
            <v-btn @click="dispSelect = true" color="secondary" width="100"
              >選択</v-btn
            >
            <v-card class="contracts mt-3 pa-3">
              <span
                v-for="(contract, index) in contractList()"
                v-html="contract + '<br/>'"
                :key="index"
              ></span>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-guters>
          <v-col cols="11">
            <v-row no-gutters justify="space-between">
              <v-col class="py-3">
                <v-btn
                  color="primary"
                  @click="clickBack()"
                  class="mr-auto"
                  width="100"
                  >戻る</v-btn
                >
              </v-col>
              <v-col>
                <v-row justify="end">
                  <v-col cols="auto">
                    <v-btn color="secondary" @click="clickRegist()" width="100"
                      >登録</v-btn
                    >
                  </v-col>
                  <v-col cols="auto" v-if="makingNewContract === false">
                    <v-btn
                      color="error"
                      @click="dialog.delete = true"
                      width="100"
                      >削除</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dispSelect" width="900px" persistent>
      <v-card class="pa-2">
        <div class="d-flex flex-row">
          <v-card-title class="s-title">契約内容選択</v-card-title>
          <v-btn icon class="ml-auto" @click="dispSelect = false"
            ><v-icon color="primary">close</v-icon></v-btn
          >
        </div>
        <v-container>
          <div v-for="(dataType, index) in dataTypeList" :key="index">
            <div class="text-subtitle-1">{{ dataType.name }}</div>
            <v-col class="ml-5">
              <v-row v-for="(deliv, index) in deliveryTypeList" :key="index">
                <v-col class="ml-5" cols="3">{{ deliv.name }}</v-col>
                <v-col
                  cols="7"
                  v-if="
                    contracts.find(
                      (contract) =>
                        contract.dataType === dataType.code &&
                        contract.delivCd === deliv.code
                    )
                  "
                >
                  <div v-if="dataType.code == frlValue">
                    <v-select
                      :value="getRsysCds(dataType.code, deliv.code)"
                      @input="setRsysCds($event, dataType.code, deliv.code)"
                      :items="frlRsysList"
                      item-text="rsysName"
                      item-value="rsysCd"
                      chips
                      multiple
                      class="pa-0 ma-0"
                    >
                      <template
                        v-slot:prepend-item
                        v-if="frlRsysList.length >= 1"
                      >
                        <v-list-item class="hederButtun">
                          <v-btn
                            class="mr-2 fixed-btn"
                            elevation="0.5"
                            color="secondary"
                            @click="allSelectRsysCd(dataType.code, deliv.code)"
                          >
                            全選択
                          </v-btn>
                          <v-btn
                            class="fixed-btn"
                            elevation="0.5"
                            color="error"
                            @click="allClearRsysCd(dataType.code, deliv.code)"
                          >
                            全解除
                          </v-btn>
                        </v-list-item>
                      </template>
                    </v-select>
                  </div>
                  <div v-else>
                    <v-select
                      :value="getPrefCodes(dataType.code, deliv.code)"
                      @input="setPrefCodes($event, dataType.code, deliv.code)"
                      :items="prefList"
                      item-text="prefName"
                      item-value="prefCd"
                      chips
                      multiple
                      class="pa-0 ma-0"
                    >
                      <template v-slot:prepend-item v-if="prefList.length >= 1">
                        <v-list-item class="hederButtun">
                          <v-btn
                            class="mr-2 fixed-btn"
                            elevation="0.5"
                            color="secondary"
                            @click="allSelectPrefCd(dataType.code, deliv.code)"
                          >
                            全選択
                          </v-btn>
                          <v-btn
                            class="fixed-btn"
                            elevation="0.5"
                            color="error"
                            @click="allClearPrefCd(dataType.code, deliv.code)"
                          >
                            全解除
                          </v-btn>
                        </v-list-item>
                      </template>
                    </v-select>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dispInitPass" width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="s-title">パスワード生成</v-card-title>
        <v-container>
          <div>パスワードを生成しました。</div>
          <div style="width: 400px">
            <v-text-field v-model="password" readonly />
          </div>
          <div>※パスワードをコピーの上、契約者にお知らせください。</div>
        </v-container>
        <v-btn
          class="d-block ml-auto"
          color="secondary"
          @click="dispInitPass = false"
          width="100"
          >確認</v-btn
        >
      </v-card>
    </v-dialog>
    <delete-dialog
      :confirmationDialogFlag.sync="dialog.delete"
      @deleteData="deleteUser()"
    />
    <message-dialog
      :messageDialogFlag.sync="dialog.message"
      :dialogText="messageDialogText"
    />
    <request-error-dialog
      :requestErrorDialogFlag.sync="dialog.requestError"
      :httpStatus="httpStatus"
      :message="requestErrorDialogMessage"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { userApi, Contract, Pref, FrlRsys } from "../api/UserApi";
import { NETWORK_ERROR } from "../router";
import MessageDialog from "./MessageDialog.vue";
import RequestErrorDialog from "./RequestErrorDialog.vue";
import { dataTypeApi, DataType } from "../api/DataTypeApi";
import { deliveryTypeApi, DeliveryType } from "../api/DeliveryTypeApi";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog.vue";
import Axios from "axios";

@Component({
  components: {
    "message-dialog": MessageDialog,
    "delete-dialog": DeleteConfirmationDialog,
    "request-error-dialog": RequestErrorDialog,
  },
})
export default class ContractDetail extends Vue {
  /** ダイアログの表示フラグ */
  dialog = {
    message: false,
    delete: false,
    requestError: false,
  };

  /** httpステータスコード */
  httpStatus = 500;

  /** リクエストエラーダイアログのテキスト */
  requestErrorDialogMessage = "";

  /** メッセージダイアログのテキスト */
  messageDialogText = {
    title: "登録完了",
    message: "登録が完了しました。",
  };

  /** 水系マスタが不明の場合の表記 */
  unknownName = "<不明>";

  // パスワード表示
  dispPass = true;

  // 契約者情報新規作成フラグ
  makingNewContract = true;

  // 契約選択
  dispSelect = false;

  // パスワード初期化
  dispInitPass = false;

  userName = "";
  userId = "";
  password = "";
  contracts: Contract[] = [];

  passEditFlg = false;

  prefList: Pref[] = [];
  frlRsysList: FrlRsys[] = [];
  dataTypeList: DataType[] = [];
  deliveryTypeList: DeliveryType[] = [];
  frlValue = 4;

  contractList(): string[] {
    const contractList: string[] = [];
    this.contracts.forEach((contract) => {
      const type = this.dataTypeList.find(
        (dataType) => dataType.code === contract.dataType
      );
      const deliv = this.deliveryTypeList.find(
        (deliv) => deliv.code === contract.delivCd
      );

      if (contract.dataType == this.frlValue) {
        if (contract.frlRsysCodeList.length > 0) {
          const rsysNames = contract.frlRsysCodeList.reduce((tmp, rsysCode) => {
            const rsys = this.frlRsysList.find(
              (rsys) => rsys.rsysCd === rsysCode
            );
            if (rsys !== undefined && rsys !== null) {
              return tmp + "　" + (rsys.rsysName || this.unknownName);
            } else {
              return tmp + "　" + this.unknownName;
            }
          }, "");
          if (type !== undefined && deliv !== undefined) {
            contractList.push(
              type.name + "（" + deliv.name + "）　" + rsysNames
            );
          }
        }
      } else {
        if (contract.prefCodeList.length > 0) {
          const prefNames = contract.prefCodeList.reduce((tmp, prefCode) => {
            const pref = this.prefList.find((pref) => pref.prefCd === prefCode);
            if (pref !== undefined && pref !== null) {
              return tmp + "　" + (pref.prefName || this.unknownName);
            } else {
              return tmp + "　" + this.unknownName;
            }
          }, "");
          if (type !== undefined && deliv !== undefined) {
            contractList.push(
              type.name + "（" + deliv.name + "）　" + prefNames
            );
          }
        }
      }
    });
    return contractList;
  }

  clickRegist() {
    if (this.$route.params.userId !== undefined) {
      this.editUser();
    } else {
      this.createUser();
    }
  }

  async createUser() {
    try {
      if (this.userId === "") {
        throw new Error("400");
      }
      const result = await userApi.createUser({
        userId: this.userId,
        userName: this.userName,
        passEditFlg: true,
        password: this.password,
        contracts: this.contracts.filter(
          (contract) =>
            contract.prefCodeList.length > 0 ||
            contract.frlRsysCodeList.length > 0
        ),
      });
      const httpStatus = result.httpStatus;

      if (httpStatus === 200) {
        this.$router.push({ name: "ContractList" });
      }
    } catch (error) {
      let newError: Error;
      if (error instanceof Error && error.message === "400") {
        newError = new Error("400");
      } else if (Axios.isAxiosError(error) && error.response) {
        newError = new Error(error.response.status.toString());
      } else {
        newError = new Error(NETWORK_ERROR);
      }
      this.requestErrorDialogMessage = "登録に失敗しました。";
      if (newError.message === "500") {
        // 500 Internal Server Error
        this.httpStatus = 500;
        this.dialog.requestError = true;
      } else if (newError.message === "400") {
        // 400 Bad Request
        this.httpStatus = 400;
        this.dialog.requestError = true;
      } else if (newError.message === "401") {
        // 401 Unauthorized
        this.httpStatus = 401;
        this.dialog.requestError = true;
      } else if (newError.message === "409") {
        // 409 Conflict Error
        this.httpStatus = 409;
        this.dialog.requestError = true;
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: newError.message });
      }
    }
  }

  async editUser() {
    try {
      if (this.userId === "") {
        throw new Error("400");
      }
      const preUserId = this.$route.params.userId;
      const result = await userApi.editUser(preUserId, {
        userId: this.userId,
        userName: this.userName,
        passEditFlg: this.passEditFlg,
        password: this.password,
        contracts: this.contracts,
      });
      const httpStatus = result.httpStatus;

      if (httpStatus === 200) {
        this.$router.push({ name: "ContractList" });
      }
    } catch (error) {
      let newError: Error;
      if (error instanceof Error && error.message === "400") {
        newError = new Error("400");
      } else if (Axios.isAxiosError(error) && error.response) {
        newError = new Error(error.response.status.toString());
      } else {
        newError = new Error(NETWORK_ERROR);
      }
      this.requestErrorDialogMessage = "登録に失敗しました。";
      if (newError.message === "500") {
        // 500 Internal Server Error
        this.httpStatus = 500;
        this.dialog.requestError = true;
      } else if (newError.message === "400") {
        // 400 Bad Request
        this.httpStatus = 400;
        this.dialog.requestError = true;
      } else if (newError.message === "401") {
        // 401 Unauthorized
        this.httpStatus = 401;
        this.dialog.requestError = true;
      } else if (newError.message === "404") {
        // 404 Not Found
        this.httpStatus = 404;
        this.dialog.requestError = true;
      } else if (newError.message === "409") {
        // 409 Conflict Error
        this.httpStatus = 409;
        this.dialog.requestError = true;
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: newError.message });
      }
    }
  }

  async deleteUser() {
    try {
      const preUserId = this.$route.params.userId;
      const result = await userApi.deleteUser(preUserId);
      const httpStatus = result.httpStatus;

      if (httpStatus === 200) {
        this.$router.push({ name: "ContractList" });
      }
    } catch (error) {
      let newError: Error;
      if (Axios.isAxiosError(error) && error.response) {
        newError = new Error(error.response.status.toString());
      } else {
        newError = new Error(NETWORK_ERROR);
      }
      this.requestErrorDialogMessage = "削除に失敗しました。";
      if (newError.message === "500") {
        // 500 Internal Server Error
        this.httpStatus = 500;
        this.dialog.requestError = true;
      } else if (newError.message === "401") {
        // 401 Unauthorized
        this.httpStatus = 401;
        this.dialog.requestError = true;
      } else if (newError.message === "404") {
        // 404 Not Found
        this.httpStatus = 404;
        this.dialog.requestError = true;
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: newError.message });
      }
    }
  }

  async clearPassword() {
    this.dispInitPass = true;
    this.dispPass = true;
    this.passEditFlg = true;

    // パスワードを乱数で決める
    const str =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const passLen = 12;
    this.password = Array.from(Array(passLen))
      .map(() => str[Math.floor(Math.random() * str.length)])
      .join("");
  }

  clickBack() {
    this.$router.push({ name: "ContractList" });
  }

  // 契約内容選択画面で入力が行われている入力欄を識別する
  targetContractSearch(
    selectDataType: number,
    selectDelivCd: number
  ): Contract | undefined {
    return this.contracts.find(
      (contract: Contract) =>
        contract.dataType === selectDataType &&
        contract.delivCd === selectDelivCd
    );
  }

  // 水害リスクラインの全選択処理
  allSelectRsysCd(selectDataType: number, selectDelivCd: number) {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );

    if (targetContract) {
      targetContract.frlRsysCodeList = this.frlRsysList.map(
        (item) => item.rsysCd
      );
    }
  }
  // 水害リスクラインの全選択解除処理
  allClearRsysCd(selectDataType: number, selectDelivCd: number) {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );

    if (targetContract) {
      targetContract.frlRsysCodeList = [];
    }
  }

  // 水害リスクライン以外の全選択処理
  allSelectPrefCd(selectDataType: number, selectDelivCd: number) {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );

    if (targetContract) {
      targetContract.prefCodeList = this.prefList.map((item) => item.prefCd);
    }
  }
  // 水害リスクライン以外の全選択解除処理
  allClearPrefCd(selectDataType: number, selectDelivCd: number) {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );

    if (targetContract) {
      targetContract.prefCodeList = [];
    }
  }

  // 水害リスクライン以外の取得処理
  getPrefCodes(selectDataType: number, selectDelivCd: number): number[] {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );
    return targetContract?.prefCodeList ?? [];
  }

  // 水害リスクライン以外の更新処理
  setPrefCodes(
    newValue: number[],
    selectDataType: number,
    selectDelivCd: number
  ): void {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );
    if (targetContract) {
      targetContract.prefCodeList = newValue;
    }
  }

  // 水害リスクラインの取得処理
  getRsysCds(selectDataType: number, selectDelivCd: number): string[] {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );
    return targetContract?.frlRsysCodeList ?? [];
  }

  // 水害リスクラインの更新処理
  setRsysCds(
    newValue: string[],
    selectDataType: number,
    selectDelivCd: number
  ): void {
    const targetContract = this.targetContractSearch(
      selectDataType,
      selectDelivCd
    );
    if (targetContract) {
      targetContract.frlRsysCodeList = newValue;
    }
  }
  async mounted() {
    if (this.$route.params.userId) {
      this.makingNewContract = false;
      this.userId = this.$route.params.userId;
      try {
        const result = await userApi.getUser(this.$route.params.userId);
        const httpStatus = result.httpStatus;
        const user = result.userResponse.result;

        if (httpStatus === 200) {
          this.userName = user.userName;
          this.userId = user.userId;
          this.password = user.password;
          this.dispPass = !user.passEditFlg;
          this.contracts = user.contracts;
        }
      } catch (error) {
        let newError: Error;
        if (Axios.isAxiosError(error) && error.response) {
          newError = new Error(error.response.status.toString());
        } else {
          newError = new Error(NETWORK_ERROR);
        }
        if (newError.message === "500") {
          // 500 Internal Server Error
          this.httpStatus = 500;
          this.dialog.requestError = true;
        } else if (newError.message === "401") {
          // 401 Unauthorized
          this.httpStatus = 401;
          this.dialog.requestError = true;
        } else if (newError.message === "404") {
          // 404 Not Found
          this.httpStatus = 404;
          this.dialog.requestError = true;
        } else {
          // 運用上起こってはいけないエラー
          this.$router.push({ name: newError.message });
        }
      }
    }

    try {
      const result = {
        prefList: await userApi.getPrefList(),
        frlRsysList: await userApi.getFrlRsysList(),
        dataTypeList: await dataTypeApi.getDataTypeList(),
        deliveryTypeList: await deliveryTypeApi.getDeliveryTypeList(),
      };
      this.prefList = result.prefList.prefListResponse.result;
      this.frlRsysList = result.frlRsysList.frlRsysListResponse.result;
      this.dataTypeList =
        result.dataTypeList.dataTypeResponse.result.dataTypeList;
      this.deliveryTypeList =
        result.deliveryTypeList.deliveryTypeResponse.result.deliveryTypeList;
    } catch (error) {
      let newError: Error;
      if (Axios.isAxiosError(error) && error.response) {
        newError = new Error(error.response.status.toString());
      } else {
        newError = new Error(NETWORK_ERROR);
      }
      if (newError.message === "500") {
        // 500 Internal Server Error
        this.httpStatus = 500;
        this.dialog.requestError = true;
      } else if (newError.message === "401") {
        // 401 Unauthorized
        this.httpStatus = 401;
        this.dialog.requestError = true;
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: newError.message });
      }
    }

    // 契約情報作成
    for (let i = 0; i < this.dataTypeList.length; i++) {
      for (let j = 0; j < this.deliveryTypeList.length; j++) {
        const target = this.contracts.find(
          (contract) =>
            contract.dataType === this.dataTypeList[i].code &&
            contract.delivCd === this.deliveryTypeList[j].code
        );
        if (target === undefined) {
          this.contracts.push({
            dataType: this.dataTypeList[i].code,
            delivCd: this.deliveryTypeList[j].code,
            prefCodeList: [],
            frlRsysCodeList: [],
          });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";

.contracts {
  overflow-y: auto;
  height: 150px;
}

/* 最上部のヘッダーを透過させずスクロールではスライドしないように固定 */
.hederButtun {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  display: flex;
  justify-content: flex-end;
}

/* v-select-list内部に自動で設定される余白の削除 */
.v-select-list.v-sheet {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* ボタン内部の文字数によるボタンサイズの変化を固定化 */
.fixed-btn {
  width: 70px;
  height: 30px;
  font-size: 12px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: unset !important;
  min-height: unset !important;
  /* 緑と赤のボタンを並べると影のつきかたにバラツキが出るため統一 */
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2) !important;
}
</style>
